import React, { useEffect } from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import useTitle from "../components/Title";
import GroupCreate from "../components/groupCreate";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";


const CreateGroup = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate("/", { replace: true });
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  useTitle("- Create Group");


  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">

          <h1 className="mt-5 event-heading-start">Create Groups.</h1>
          <p className="event-sub-text mb-3"> This is where user groups will be managed.  </p>

            <GroupCreate />
  
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CreateGroup;
